<template>
  <b-container>
    <h1 class="text-center pt-4 pb-4">{{ $t("title.budgetManagement") }}</h1>

    <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem;" class="spinner" variant="success" label="Spinning"
        disabled="labelStatus"></b-spinner>
    </div>

    <div v-else>
      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model.trim="$v.year.$model" :options="years" v-on:change="OnYearClick"></b-form-select>
          <div class="text-danger" v-if="!$v.year.required && $v.year.$dirty">{{ $t("info.required") }}</div>
        </b-col>
      </b-row>

      <!--<UploadCsv ref="csvfile" v-if="year" :year="year"/>
      <b-button class="mt-4" variant="success" :disabled="disabled" @click="submitValue()">{{ $t("action.submit") }}</b-button>-->

      <div v-if="success" class="pt-4">
        <b-alert show variant="success">
          <p>{{ $t("info.successgeneric") }}</p>
        </b-alert>
      </div>

      <div v-if="error" class="pt-4">
        <b-alert show variant="danger">
          <p>{{ error }}</p>
        </b-alert>
      </div>

    </div>

    <div class="mt-2" v-if="budgetsList && budgetsList.length > 0">

      <b-row class="mt-2">
        <b-col sm="4" class="mt-4">
          <b-form-select v-model="building" :options="buildings" v-on:change="OnBuildingClick"></b-form-select>
        </b-col>
      </b-row>

      <b-row class="pt-2">
        <b-col sm="4" class="mt-2">
          <b-form-select v-model="perPage" :options="options"></b-form-select>
        </b-col>
        <b-col sm="4" class="mt-2">
          <b-form-input v-model="search" :placeholder="$t('action.search')"></b-form-input>
          <b-button variant="link" @click="resetTable()">{{ $t('action.reset') }}</b-button>
        </b-col>
        <b-col sm="4" class="mt-2">
          <div>{{ $t("label.tablesize") }} {{ rows }}</div>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col class="lgTable">
          <b-table id="budgetTable" stacked="lg" bordered :fields="myfields" :items="items" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :per-page="perPage" :current-page="currentPage">
            <template v-slot:cell(NOMDIV)="row">
              <b-button variant="link" class="ml-2" size="sm" @click="openmodal('editBudget', row.item, 'editBudget')">{{
                row.item.NOMDIV }}</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <b-row class="pt-4">
        <b-col sm="6" class="mt-2">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
            aria-controls="budgetTable"></b-pagination>
        </b-col>
      </b-row>

      <b-button class="mt-2" variant="danger" @click="openmodal('removeBudget', null, null)">{{ $t('action.remove')
      }}</b-button>

    </div>

    <div v-else>
      <div v-if="year">
        <div class="text-center pt-2">{{ $t("label.empty") }}</div>
        <div v-if="building">
          <b-button variant="success" @click="openmodal('editBudget', setBudgetForMissingBuilding, 'insertBudget')">{{ $t('action.addBudgetBuildingData') }}</b-button>
        </div>
        <div v-else>
          <b-button variant="success" @click="addBudgetDataForThisYear()">{{ $t('action.addBudgetDataForThisYear')
          }}</b-button>
        </div>

      </div>
    </div>

    <b-modal id="editBudget" :title="$t('title.budgetManagement')" hide-footer>
      <EditBudget :budget="rowItem" modalid="editBudget" />
    </b-modal>

    <b-modal id="removeBudget" :title="$t('title.budgetManagement')" hide-footer>
      <DeleteBudget :year="year" modalid="removeBudget" />
    </b-modal>

  </b-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from 'vuelidate/lib/validators';
import { mappBuildingDataForSelect } from '../../../assets/Utils.js';
//import UploadCsv from './UploadCsv.vue';  
import { globalF } from '../../Helpers';
import EditBudget from "./EditBudget.vue";
import DeleteBudget from "./DeleteBudgetModal.vue";

export default {
  mixins: [globalF],
  data() {
    return {
      disabled: false,
      success: false,
      error: "",
      errorfields: "",
      buildingList: [],
      buildings: [],
      building: this.getbuilding(),
      sortBy: 'NOMDIV',
      sortDesc: true,
      perPage: 10,
      currentPage: 1,
      search: "",
      budgets: [],
      budgetsList: [],
      selected: [],
      options: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      year: null,
      spinner: false,
      rowItem: null
    }
  },
  validations() {
    return { year: { required } }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      this.getBudgetByYear();
    })
  },
  computed: {
    url: function () {
      return this.getUrl();
    },
    rows() {
      return this.items.length;
    },
    items: function () {
      let mydatalist = this.budgetsList;

      return mydatalist.filter(p => p.NOMDIV.toLowerCase().includes(this.search));
    },
    myfields: function () {
      return [
        { key: 'NOMDIV', sortable: true, label: "NOMDIV" },
        { key: 'JAN', label: "JAN" },
        { key: 'FEB', label: "FEB" },
        { key: 'MARCH', label: "MARCH" },
        { key: 'APRIL', label: "APRIL" },
        { key: 'MAY', label: "MAY" },
        { key: 'JUNE', label: "JUNE" },
        { key: 'JULY', label: "JULY" },
        { key: 'AUGUST', label: "AUGUST" },
        { key: 'SEPT', label: "SEPT" },
        { key: 'OCT', label: "OCT" },
        { key: 'NOV', label: "NOV" },
        { key: 'DECEMBER', label: "DEC" },
      ]
    },
    years: function () {
      let current = moment().year().toString();
      let nextYear = moment().add(1, 'y').year().toString();
      let nextNextYear = moment().add(2, 'y').year().toString();

      return [
        { value: null, text: this.$t('label.year') },
        { value: current, text: current },
        { value: nextYear, text: nextYear },
        { value: nextNextYear, text: nextNextYear }
      ];
    },
    setBudgetForMissingBuilding: function () {
      let obj = {
        NOMDIV: this.building.NOMDIV,
        NOCIE: this.building.NOCIE,
        NODIV: this.building.NODIV,
        JAN: 0,
        FEB: 0,
        MARCH: 0,
        APRIL: 0,
        MAY: 0,
        JUNE: 0,
        JULY: 0,
        AUGUST: 0,
        SEPT: 0,
        OCT: 0,
        NOV: 0,
        DECEMBER: 0,
        YEAR: this.year
      }
      return obj;
    }
  },
  methods: {
    openmodal: function (id, rowItem, request) {
      if (rowItem, request) {
        rowItem.request = request;
        this.rowItem = rowItem;
      }
      this.$bvModal.show(id);
    },
    OnYearClick: function () {
      this.building = null;
      if (this.year) {
        this.getBudgetByYear();
      }
    },
    OnBuildingClick: function () {
      this.search = "";
      this.error = "";
      this.success = false;
      this.budgetsList = [];

      if (this.building) {
        this.budgetsList = this.budgets.filter(a => a.NOCIE === this.building.NOCIE && a.NODIV === this.building.NODIV);
      }
      else {
        this.budgetsList = this.budgets
      }

    },
    getbuilding: function () {
      return null;
    },
    getBudgetByYear() {
      this.spinner = true;
      let urls = this.$store.getters.getUrlsList;
      let url = urls[process.env.VUE_APP_WHERE].json;

      axios.post(url, { request: "getBudgets", year: this.year }, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => {
          this.spinner = false;
          this.buildingList = response.data.buildings;
          this.setBuildingList(response.data.buildings);
          this.budgets = response.data.budgets;
          this.setBudget(response.data.budgets, response.data.buildings);
          this.OnBuildingClick();
        })
        .catch(() => {
          this.spinner = false;
          this.error = this.$t('info.errorgeneric');
        });
    },
    setBudget: function (budgetsList, buildings) {

      this.budgetsList = budgetsList.map(a => {
        let find = buildings.find(b => b.NOCIE === a.NOCIE && b.NODIV === a.NODIV);
        a.NOMDIV = "";
        if (find) {
          a.NOMDIV = find.NOMDIV;
        }
        return a;
      });
    },
    setBuildingList: function (buildings) {
      let res = [];
      if (buildings) {
        res = mappBuildingDataForSelect(buildings);
        //res.unshift({value: 'All', text: this.$t('label.all')});
      }
      res.unshift({ value: null, text: this.$t('label.properties') });
      this.buildings = res;
    },
    addBudgetDataForThisYear: function () {
      this.error = "";
      this.spinner = true;

      let obj = {
        request: "addBudgetDataForThisYear",
        JAN: 0,
        FEB: 0,
        MARCH: 0,
        APRIL: 0,
        MAY: 0,
        JUNE: 0,
        JULY: 0,
        AUGUST: 0,
        SEPT: 0,
        OCT: 0,
        NOV: 0,
        DECEMBER: 0,
        YEAR: this.year
      }

      axios
        .post(this.url, obj, {
          headers: { "Content-Type": "application/json" },
        })
        .then(() => {
          this.disabled = false;
          this.spinner = false;
          this.getBudgetByYear();
        })
        .catch(() => {
          this.error = this.$t("info.errorgeneric");
          this.disabled = false;
          this.spinner = false;
        });
    },
    resetTable: function () {
      this.search = "";
      this.building = null;
      this.setBudget(this.budgets, this.buildingList)
      this.success = false;
      this.error = false;
    }
  },
  components: {
    //UploadCsv
    EditBudget,
    DeleteBudget
  }
}
</script>